import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import PropTypes from 'prop-types';
import React from 'react';
import _ from 'lodash';
import compose from '../../../hoc/compose';
import displayNames from '../../displayNames';
var DropDownStickyFooter = /*#__PURE__*/function (_React$Component) {
  function DropDownStickyFooter() {
    _classCallCheck(this, DropDownStickyFooter);
    return _callSuper(this, DropDownStickyFooter, arguments);
  }
  _inherits(DropDownStickyFooter, _React$Component);
  return _createClass(DropDownStickyFooter, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (_.isFunction(this.props.registerStickyFooter)) {
        this.props.registerStickyFooter(this);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (_.isFunction(this.props.registerStickyFooter)) {
        this.props.registerStickyFooter(null);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this = this;
      return /*#__PURE__*/React.createElement('footer', {
        onClick: function onClick() {
          if (_this.props.closeOnClick && _.isFunction(_this.props.toggleOptions)) {
            _this.props.toggleOptions();
          }
        },
        className: this.props.getClassName('control-dropdown-sticky-footer'),
        'data-aid': this.props.automationId,
        'data-hook': this.props.dataHook
      }, this.props.children);
    }
  }]);
}(React.Component);
DropDownStickyFooter.displayName = displayNames.DROP_DOWN_STICKY_FOOTER;
DropDownStickyFooter.propTypes = {
  registerStickyFooter: PropTypes.func,
  closeOnClick: PropTypes.bool
};
DropDownStickyFooter.defaultProps = {};
export default compose(DropDownStickyFooter);